enum SearchEventTypes {
    HitsRendered = 'HitsRendered',
    KeyUp = 'KeyUp',
    NoResults = 'NoResults',
    RefinementChanged = 'RefinementChanged'
}

interface SearchEventHitsRendered {
    count: number;
    currentHits: Array<any>;
    isFirstRender: boolean;
}

interface SearchEventRefinementChanged {
    count: number;
}

interface SearchEventNoResults {
    count: number;
}

interface SearchEventKeyUp {
    value: string;
    isEmpty: boolean;
    count: number;
}

interface SearchEventsData {
    currentPageHits?: Array<any>;
    showMore?: CallableFunction;
    widgetParams?: any;
    renderOptions?: any;
    hitsCount?: number | undefined;
    container?: any;
}

class SearchEvents {
    dispatcher: HTMLElement | undefined;

    private _currentPageHits;
    private _showMore: CallableFunction;
    private _widgetParams;
    private _renderOptions;
    private _hitsCount: number | undefined;
    private _firstRender: boolean | undefined;

    constructor(searchBox: HTMLElement) {
        this.dispatcher = searchBox;
    }

    public updateData(data: SearchEventsData) {
        this._currentPageHits = data.currentPageHits !== undefined ? data.currentPageHits : this._currentPageHits;
        this._hitsCount = data.hitsCount !== undefined ? data.hitsCount : this._hitsCount;
        this._showMore = data.showMore !== undefined ? data.showMore : this._showMore;
        this._widgetParams = data.widgetParams !== undefined ? data.widgetParams : this._widgetParams;
        this._renderOptions = data.renderOptions !== undefined ? data.renderOptions : this._renderOptions;
    }

    private async emitRefinementChanged() {
        this.dispatcher.dispatchEvent(new CustomEvent(SearchEventTypes.RefinementChanged, {
            detail: {
                count: this._hitsCount
            }
        }));
    }

    private async emitNoResults() {
        this.dispatcher.dispatchEvent(new CustomEvent(SearchEventTypes.NoResults, {
            detail: {
                count: this._hitsCount
            }
        }));
    }

    private async emitKeyUp(data: any) {
        this.dispatcher.dispatchEvent(new CustomEvent(SearchEventTypes.KeyUp, {
            detail: {
                value: data.input.value,
                isEmpty: data.input.value === '' ? true : false,
                count: this._hitsCount,
            }
        }));
    }

    private async emitHitsRendered() {
        this.dispatcher.dispatchEvent(new CustomEvent(SearchEventTypes.HitsRendered, {
            detail: {
                count: this._hitsCount,
                currentHits: this._currentPageHits,
                isFirstRender: this.isFirstRender()
            }
        }));
    }

    private isFirstRender(): boolean {
        if (this._firstRender === undefined) {
            this._firstRender = true;
        } else if (this._firstRender == true) {
            this._firstRender = false;
        }
        return this._firstRender;
    }

    public emit(eventType: SearchEventTypes, data?: any) {
        if (this.dispatcher) {
            if (eventType == SearchEventTypes.HitsRendered) {
                this.emitHitsRendered();
            } else if (eventType == SearchEventTypes.KeyUp) {
                this.emitKeyUp(data);
            } else if (eventType == SearchEventTypes.NoResults) {
                this.emitNoResults();
            } else if (eventType == SearchEventTypes.RefinementChanged) {
                this.emitRefinementChanged();
            }
        }
    }

    public addListener(eventType: SearchEventTypes, fn: CallableFunction) {
        if (this.dispatcher) {
            if (eventType == SearchEventTypes.HitsRendered) {
                this.dispatcher.addEventListener(SearchEventTypes.HitsRendered, (e: CustomEvent) => {
                    fn(e.detail as SearchEventHitsRendered);
                });
            } else if (eventType == SearchEventTypes.KeyUp) {
                this.dispatcher.addEventListener(SearchEventTypes.KeyUp, (e: CustomEvent) => {
                    fn(e.detail as SearchEventKeyUp);
                });
            } else if (eventType == SearchEventTypes.NoResults) {
                this.dispatcher.addEventListener(SearchEventTypes.NoResults, (e: CustomEvent) => {
                    fn(e.detail as SearchEventNoResults);
                });
            } else if (eventType == SearchEventTypes.RefinementChanged) {
                this.dispatcher.addEventListener(SearchEventTypes.RefinementChanged, (e: CustomEvent) => {
                    fn(e.detail as SearchEventRefinementChanged);
                });
            }
        }
    }
}

export default SearchEvents;
export { SearchEventHitsRendered, SearchEventTypes, SearchEventKeyUp, SearchEventNoResults};